import { SET_EDITFONT } from '../actions';

const fontedit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITFONT:
      return [...action.value];  
    default: return state;
  }
}

export default fontedit;
